import { combineReducers } from '@reduxjs/toolkit'
import { timeline } from './data/timeline'
import { marker } from './data/marker'
import { timespan } from './data/timespan'
import { timelineGridItem } from './data/timeline_grid_item'
import { category } from './data/category'
import { photo } from './data/photo'
import { user } from './data/user'
import { group } from './data/group'
import { comment } from './data/comment'
import { toast } from './data/toast'
import { tag } from './data/tag'
import { ad } from './data/ad'
import { embedKey } from './data/embed_key'
import { endpoint } from './data/endpoint'
import { flashMessage } from './data/flash_message'
import { colorScheme } from './data/color_scheme'
import { permission } from './data/permission'
import { membership } from './data/membership'
import { accountMembership } from './data/account_membership'
import invitation from './data/invitation'
import database from './data/database'
import table from './data/table'
import field from './data/field'
import row from './data/row'
// views
import view from './data/view'
import gridView from './data/grid_view'
import stackView from './data/stack_view'
import horizontalTimelineView from './data/horizontal_timeline_view'
import combiTimelineView from './data/combi_timeline_view'

import timelineShow from './ui/timeline_show'

import commentModeration from '../features/comment_moderation'
import entitySaver from '../features/entity_saver'
import groupTimelines from '../features/group_timelines'
import photoLibrary from '../features/photo_library'
import sharing from '../features/sharing'
import selectable from '../features/selectable'
import siteSearch from '../features/site_search'
import filters from '../features/filters'
import viewOptions from '../features/view_options'
import redirection from '../features/redirection'
import sorting from '@features/sorting/reducers'
import filtering from '@features/filtering/reducers'
import resourcePermissions from '../features/resource_permissions'

import { viewsApi } from '@api/views_web_api'
import fieldApi from '@features/add_remove_field'

const dataReducers = {
  // regular entities
  timelines: timeline,
  markers: marker,
  timespans: timespan,
  categories: category,
  photos: photo,
  comments: comment,
  users: user,
  groups: group,
  tags: tag,
  permissions: permission,
  memberships: membership,
  timelineGridItems: timelineGridItem,
  accountMemberships: accountMembership,
  invitations: invitation,

  // Unbound reducers
  databases: database,
  tables: table,
  fields: field,
  rows: row,

  // views
  views: view,
  gridViews: gridView,
  stackViews: stackView,
  horizontalTimelineViews: horizontalTimelineView,
  combiTimelineViews: combiTimelineView,
  viewOptions, // for changing view settings

  toasts: toast,
  ads: ad,
  embedKeys: embedKey,
  endpoints: endpoint,
  flashMessages: flashMessage,
  colorSchemes: colorScheme,
}

const uiReducers = {
  timelineShow,
}

export const staticReducers = {
  data: combineReducers(dataReducers),
  ui: combineReducers(uiReducers),
  commentModeration,
  groupTimelines,
  photoLibrary,
  sharing,
  selectable,
  entitySaver,
  siteSearch,
  filters,
  redirection,
  resourcePermissions,
  viewsApi: viewsApi.reducer,
  sorting,
  filtering,
  fieldApi,
}
